import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, 'client-id'] as const

export type hlnfCredType = (typeof credentialTypes)[number]
export const hlnf: CarrierDef<hlnfCredType> = {
  name: 'Hot-Line Transport LTD',
  scac: 'hlnf',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating', 'tracking', 'pickup'],
  credentialConfig: {
    'client-id': { customerIdentifier: true },
  },
}
